import { render } from "./ManageVision.vue?vue&type=template&id=72349120"
import script from "./ManageVision.vue?vue&type=script&lang=js"
export * from "./ManageVision.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__